import React, { useState, ReactElement } from 'react';
import styled from '@emotion/styled';

interface Props {
  children: ReactElement | ReactElement[];
}

const TabHeaderContainer = styled.nav`
  width: 100%;
  height: 35px;
  background: transparent;
  display: flex;
`;

const NavItem = styled.div<{ selected: boolean; beforeSelected: boolean }>`
  background-color: transparent;
  display: flex;
  height: 100%;
  min-width: 128px;
  justify-content: center;
  align-items: center;
  line-height: 16px;
  font-size: 18px;
  cursor: pointer;
  color: ${s => (s.selected ? '#0076CE' : '#809DC4')};
  font-weight: 600;
  border-bottom: ${p => (p.selected ? '4px solid #0076CE ' : '4px solid transparent')};
  transition: border-color 0.5s ease;
`;

const IconWrapper = styled.span`
  padding-right: 8px;
`;

const TabContent = styled.div`
  width: 100%;
  height: 100%;
`;

export const PrimaryTabs = ({ children }: Props) => {
  if (!children) {
    throw new Error('Secondary Tabs requires children of Tab type.');
  }

  if (!(children as ReactElement[]).length) {
    children = [children] as ReactElement[]; // allow one tab
  }

  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  const changeTab = (tabIndex: number) => {
    setCurrentTabIndex(tabIndex);
  };
  const isBeforeSelected = (tabIndex: number) => {
    const distance = currentTabIndex - tabIndex;
    return distance === 1;
  };
  return (
    <>
      <TabHeaderContainer>
        {(children as ReactElement[]) &&
          (children as ReactElement[]).map((child, tabIndex) => {
            return (
              <NavItem
                selected={currentTabIndex === tabIndex}
                beforeSelected={isBeforeSelected(tabIndex)}
                key={tabIndex}
                onClick={() => {
                  changeTab(tabIndex);
                }}
              >
                <IconWrapper>{child && child.props.icon}</IconWrapper>
                {child && child.props.title}
              </NavItem>
            );
          })}
      </TabHeaderContainer>

      <TabContent>{children[currentTabIndex].props.children}</TabContent>
    </>
  );
};

export default PrimaryTabs;
